var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-fab-transition",
        [
          _vm.canPrint
            ? _c(
                "v-btn",
                {
                  attrs: {
                    fab: "",
                    rounded: "",
                    color: "primary",
                    bottom: "",
                    loading: _vm.loading || _vm.isLoading || _vm.showLoading,
                    right: "",
                    disabled: _vm.loading || _vm.isLoading || _vm.showLoading,
                    fixed: "",
                  },
                  on: { click: _vm.toPrint },
                },
                [
                  _c("span", { staticClass: "material-icons-round" }, [
                    _vm._v("print"),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c("ContentLayout", {
        ref: "print",
        attrs: {
          title: _vm.$t("label_essweb_RosterRecord_list_title"),
          pad: "0",
          hiddenNav: "",
          backgroundClass: "white",
          widthClass: "min-1600",
        },
        scopedSlots: _vm._u([
          {
            key: "page-main",
            fn: function () {
              return [
                _c(
                  "v-container",
                  {
                    staticClass: "pa-0 ma-0",
                    style: {
                      height: _vm.$vuetify.breakpoint.height + "px",
                      overflow: "overlay",
                    },
                    attrs: { fluid: "" },
                  },
                  [
                    _vm.page_params
                      ? _c("RosterPlan", {
                          ref: "printarea2",
                          attrs: {
                            id: "pdfDom",
                            token: _vm.page_params.token,
                            cycleType: _vm.cycleType,
                            showExportIn: _vm.showExportIn,
                            toDo: _vm.toDo,
                            showRosterForm: _vm.showRosterForm,
                            showRecalcul: _vm.showRecalcul,
                            startTime: _vm.startTime,
                            isEdited: _vm.isEdited,
                            selectStartDate: _vm.startDate,
                            selectEndDate: _vm.endDate,
                            endTime: _vm.endTime,
                          },
                          on: {
                            closeExportIn: function ($event) {
                              _vm.showExportIn = false
                            },
                            closeCalcul: function ($event) {
                              _vm.showRecalcul = false
                            },
                            loadingData: function (v) {
                              _vm.showLoading = v
                            },
                            back: function ($event) {
                              _vm.isEdited = false
                              _vm.dateTerminal = {
                                start: "",
                                end: "",
                                vaue: "",
                              }
                            },
                            closeRosterForm: function ($event) {
                              _vm.showRosterForm = false
                            },
                            onTrigerPage: function (logic) {
                              _vm.toResetTime(logic)
                            },
                            check: function (staffs) {
                              _vm.selectStaffs = staffs
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "v-container",
                  {
                    staticClass:
                      "ma-0 pa-0 d-flex flex-row justify-space-around",
                    attrs: { fluid: "" },
                  },
                  [
                    _c(
                      "v-container",
                      { staticClass: "ma-0 pa-0 mr-6", attrs: { fluid: "" } },
                      [
                        _c("v-sheet", { staticClass: "text-subtile-2 pl-4" }, [
                          _vm._v(
                            _vm._s(_vm.$t("label_essweb_shift_list_title")) +
                              "："
                          ),
                        ]),
                        _c("Tabler", {
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.desserts,
                            avPerPage: 50,
                            contentClass: " pa-4 py-0",
                            defaultDense: "",
                            showFooter: false,
                            sortBy: ["startTime"],
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item.color",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    "div",
                                    { staticStyle: { "max-width": "20px" } },
                                    [
                                      _c("svg-icon", {
                                        attrs: {
                                          size: "24",
                                          fill: item.color_code,
                                          iconClass: "LabeledColour",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.name",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text--primary table-title",
                                      attrs: {
                                        title: _vm.$getCommonLangValue(
                                          item.shift_name
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              item.shift_name
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "table-subtitle text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              item.shift_description
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.abbr",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text--primary table-title",
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.shift_abbr) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.startTime",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text--primary table-title",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$timeMachine(
                                              item.start_utc_time
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.endTime",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text--primary table-title",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$timeMachine(item.end_utc_time)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.count",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text--primary table-title",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.total_working_minutes) +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_system_minutesLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c("v-spacer"),
                    _c(
                      "v-container",
                      { staticClass: "pa-0 ma-0 ml-6", attrs: { fluid: "" } },
                      [
                        _c("v-sheet", { staticClass: "text-subtile-2 ml-6" }, [
                          _vm._v(
                            _vm._s(_vm.$t("label_essweb_holiday_list_title")) +
                              "："
                          ),
                        ]),
                        _c("Tabler", {
                          attrs: {
                            headers: _vm.headers1,
                            items: _vm.desserts1,
                            defaultDense: "",
                            contentClass: " pa-4 py-0",
                            avPerPage: 50,
                            showFooter: false,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item.name",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$getCommonLangValue(item.holiday_name)
                                    )
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.date",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$getDateTime(
                                        item.holiday_utc_date,
                                        "YYYY/MM/DD"
                                      )
                                    )
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.zone",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$getUtcByCode(item.holiday_time_zone)
                                    )
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "page-actions",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
          {
            key: "tools-main",
            fn: function () {
              return [_c("printLoading", { attrs: { show: _vm.showLoading } })]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }